import { usePagination, DOTS } from '../../hooks/usePagination'
import React, { useEffect, useState } from 'react'
import DynamicHeroIcon from './DynamicHeroIcon'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

export interface PaginationProps {
    totalCount: number
    siblingCount?: number
    pageSize: number
    useUrl?: boolean
    pageChange?: (page: number) => void
}

const Pagination: React.FC<PaginationProps> = (props) => {
    const { t } = useTranslation(['common'])
    const router = useRouter()
    const { page } = router.query

    const [currentPage, setCurrentPage] = useState<number>(page && page !== '' ? parseInt(page.toString()) : 1)

    const { totalCount, siblingCount = 1, pageSize, useUrl = true, pageChange } = props

    const paginationRange = usePagination(totalCount, pageSize, siblingCount, currentPage)

    useEffect(() => {
        if (useUrl) {
            setCurrentPage(page && page !== '' ? parseInt(page.toString()) : 1)
        }
    }, [page])

    const onPageChange = async (page: number) => {
        if (useUrl) {
            const query = new URLSearchParams(window.location.search)
            if (query.has('page')) {
                query.set('page', page.toString())
            } else {
                query.append('page', page.toString())
            }

            await router.push(window.location.pathname + '?' + query.toString())
            // setCurrentPage(page)
        } else if (pageChange) {
            setCurrentPage(page)
            pageChange(page)
        }
    }

    if (paginationRange === undefined) {
        return <></>
    }

    if (currentPage === 0 || paginationRange.length < 2) {
        return null
    }

    const lastPage = paginationRange[paginationRange.length - 1]

    const onNext = async () => {
        if (currentPage === paginationRange[paginationRange.length - 1]) return
        await onPageChange(currentPage + 1)
    }

    const onPrevious = async () => {
        if (currentPage === 1) return
        await onPageChange(currentPage - 1)
    }

    return (
        <nav className="flex justify-between items-center sm:px-0">
            <div className="">
                <button
                    className={`
                                ${currentPage === 1 ? 'opacity-0 cursor-default' : 'opacity-100'}
                        inline-flex items-center py-4 text-sm text-gray-500 hover:text-crusta-700 transition-all duration-300 ease-in-out group
                    `}
                    onClick={onPrevious}
                >
                    <DynamicHeroIcon icon="ChevronLeftIcon" className="w-5 h-5" aria-hidden="true" />
                    {t('previous')}
                </button>
            </div>
            <div className="md:hidden text-sm text-gray-500">
                {currentPage}/{lastPage}
            </div>
            <div className="hidden md:flex">
                {paginationRange.map((pageNumber) => {
                    if (pageNumber === DOTS) {
                        return (
                            <div key={pageNumber} className="inline-flex items-center p-4 text-sm text-gray-500">
                                &#8230;
                            </div>
                        )
                    }

                    return (
                        <button
                            key={pageNumber}
                            className={`
                                ${
                                    currentPage === pageNumber
                                        ? 'text-crusta-500 border-mariner-500'
                                        : 'text-gray-500 border-transparent'
                                }
                                border-b-2 transition-all duration-300 inline-flex items-center p-4 text-sm  hover:text-crusta-500 group
                            `}
                            onClick={() => onPageChange(parseInt(pageNumber as string))}
                        >
                            {pageNumber}
                        </button>
                    )
                })}
            </div>

            <div className="">
                <button
                    className={`
                                ${currentPage === lastPage ? 'opacity-0 cursor-default' : 'opacity-100'}
                        inline-flex items-center py-4 text-sm text-gray-500 hover:text-crusta-700 transition-all duration-300 ease-in-out group
                    `}
                    onClick={onNext}
                >
                    {t('next')}
                    <DynamicHeroIcon icon="ChevronRightIcon" className="w-5 h-5" aria-hidden="true" />
                </button>
            </div>
        </nav>
    )
}

export default Pagination
